var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 20.4q-.65 0-1.1-.45-.45-.45-.45-1.075V7.7H6v11.15q0 .25.2.438.2.187.425.187H14.8v.925Zm2.85-2.85q-.65 0-1.1-.437-.45-.438-.45-1.088V5.375q0-.65.45-1.1.45-.45 1.1-.45h7.675q.65 0 1.1.45.45.45.45 1.1v10.65q0 .65-.45 1.088-.45.437-1.1.437Zm0-.925h7.675q.25 0 .438-.187.187-.188.187-.413V5.375q0-.225-.187-.425-.188-.2-.438-.2H9.475q-.225 0-.425.2-.2.2-.2.425v10.65q0 .225.2.413.2.187.425.187Zm-.625 0V4.75v11.875Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.be4abd17b9b0ce75573c6ccbbb059c30.svg";
export { ForwardRef as ReactComponent };